export const API_MESSAGE_DELETE_REQUEST = 'API_MESSAGE_DELETE_REQUEST';
export const API_MESSAGE_DELETE_SUCCESS = 'API_MESSAGE_DELETE_SUCCESS';
export const API_MESSAGE_DELETE_FAILURE = 'API_MESSAGE_DELETE_FAILURE';

export const messageDeleteRequest = payload => ({
  type: API_MESSAGE_DELETE_REQUEST,
  payload,
});

export const messageDeleteSuccess = payload => ({
  type: API_MESSAGE_DELETE_SUCCESS,
  payload,
});

export const messageDeleteFailure = payload => ({
  type: API_MESSAGE_DELETE_FAILURE,
  payload,
});

const initialState = {
  selectedMessageId: null,
  isFetched: false,
  fetching: false,
  error: null,
  messageDelete: null,
  deleted: false,
};

export function messageDeleteReducer(state = initialState, action) {
  switch (action.type) {
    case API_MESSAGE_DELETE_REQUEST:
      return {
        ...state,
        fetching: true,
        selectedMessageId: action.payload,
      };
    case API_MESSAGE_DELETE_SUCCESS:
      return {
        ...state,
        isFetched: true,
        fetching: false,
        messageDelete: action.payload,
        deleted: true,
      };
    case API_MESSAGE_DELETE_FAILURE:
      return {
        ...state,
        fetching: false,
        error: action.error,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/messageDelete.js